import { useState } from 'react';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { Banknote, CreditCard, Smartphone, Building2, HandCoins, CircleDollarSign } from 'lucide-react';

const PAYMENT_PRESETS = [
  { id: 'immediate', label: 'Paiement immediat', value: 'Paiement immediat' },
  { id: '10days', label: '10 jours net', value: 'Paiement a 10 jours net' },
  { id: '30days', label: '30 jours net', value: 'Paiement a 30 jours net' },
  { id: '60days', label: '60 jours net', value: 'Paiement a 60 jours net' },
  { id: 'receipt', label: 'A reception', value: 'Payable a reception de la facture' },
  { id: 'end_month', label: 'Fin de mois', value: 'Paiement a 30 jours fin de mois' },
];

const PAYMENT_METHODS = [
  { id: 'virement', label: 'Virement bancaire', icon: Building2, color: 'bg-blue-50 text-blue-600 border-blue-200' },
  { id: 'twint', label: 'Twint', icon: Smartphone, color: 'bg-slate-900 text-white border-slate-900' },
  { id: 'cash', label: 'Especes', icon: Banknote, color: 'bg-emerald-50 text-emerald-600 border-emerald-200' },
  { id: 'card', label: 'Carte', icon: CreditCard, color: 'bg-violet-50 text-violet-600 border-violet-200' },
  { id: 'paypal', label: 'PayPal', icon: CircleDollarSign, color: 'bg-blue-50 text-blue-700 border-blue-200' },
  { id: 'other', label: 'Autre', icon: HandCoins, color: 'bg-slate-50 text-slate-600 border-slate-200' },
];

const PaymentTermsField = ({ value, onChange, methods, onMethodsChange }) => {
  const selectedMethods = methods || [];

  const toggleMethod = (methodId) => {
    if (!onMethodsChange) return;
    const updated = selectedMethods.includes(methodId)
      ? selectedMethods.filter(m => m !== methodId)
      : [...selectedMethods, methodId];
    onMethodsChange(updated);
  };

  const applyPreset = (preset) => {
    onChange(preset.value);
  };

  return (
    <div className="space-y-3" data-testid="payment-terms-field">
      {/* Quick presets */}
      <div>
        <Label className="text-xs text-slate-500 mb-1.5 block">Delai de paiement</Label>
        <div className="flex flex-wrap gap-1.5">
          {PAYMENT_PRESETS.map(p => (
            <button
              key={p.id}
              type="button"
              onClick={() => applyPreset(p)}
              className={`text-xs px-2.5 py-1 rounded-md border transition-colors ${value === p.value ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300 hover:bg-blue-50'}`}
              data-testid={`preset-${p.id}`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {/* Payment methods */}
      {onMethodsChange && (
        <div>
          <Label className="text-xs text-slate-500 mb-1.5 block">Moyens de paiement acceptes</Label>
          <div className="flex flex-wrap gap-1.5">
            {PAYMENT_METHODS.map(m => {
              const Icon = m.icon;
              const isSelected = selectedMethods.includes(m.id);
              return (
                <button
                  key={m.id}
                  type="button"
                  onClick={() => toggleMethod(m.id)}
                  className={`text-xs px-2.5 py-1.5 rounded-md border flex items-center gap-1.5 transition-all ${isSelected ? m.color + ' font-medium ring-1 ring-offset-1 ring-current' : 'bg-white text-slate-400 border-slate-200 hover:text-slate-600 hover:border-slate-300'}`}
                  data-testid={`method-${m.id}`}
                >
                  <Icon className="w-3 h-3" />{m.label}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Free text */}
      <div>
        <Label className="text-xs text-slate-500 mb-1.5 block">Conditions personnalisees</Label>
        <Textarea
          placeholder="Conditions de paiement..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={2}
          className="text-sm"
          data-testid="payment-terms-input"
        />
      </div>
    </div>
  );
};

export { PAYMENT_METHODS, PAYMENT_PRESETS };
export default PaymentTermsField;
